import { ISignalPlanVisual } from "@types"
import { protectedApi } from "store/Api";

interface IFetchSignalPlanVisualArgs {
    beginDate: string;
    endTime: string;
}


const signalPlanVisualMissingDataApi = protectedApi.injectEndpoints({

    endpoints: (builder) => ({
        fetchSignalPlanVisualMissingData: builder.mutation<ISignalPlanVisual[], IFetchSignalPlanVisualArgs>({
            query: ({ beginDate, endTime }) => {
                return {
                    method: "GET",
                    url: `data/signal_plan/missing_data?beginDate=${beginDate}&endTime=${endTime}`,
                }
            },
        }),
    }),
})

export const { useFetchSignalPlanVisualMissingDataMutation } = signalPlanVisualMissingDataApi
